module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-layout"
  }, [(_vm.$slots.header) ? _c('div', {
    staticClass: "form-layout__header"
  }, [_vm._t("header")], 2) : _vm._e(), (_vm.$slots.textarea) ? _c('div', {
    staticClass: "form-layout__row"
  }, [_vm._t("textarea")], 2) : _vm._e(), (_vm.$slots.radio) ? _c('div', {
    staticClass: "form-layout__row form-layout__row_radio"
  }, [_vm._t("radio")], 2) : _vm._e(), (_vm.$slots.input) ? _c('div', {
    staticClass: "form-layout__row"
  }, [_vm._t("input")], 2) : _vm._e(), (_vm.$slots.button) ? _c('div', {
    staticClass: "form-layout__row form-layout__row_button"
  }, [_vm._t("button")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61dd3d13","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modalform/components/Layout.vue
// module id = a6a4ac1f9dd6346eb75b
// module chunks = 0